module.exports = __webpack_public_path__ + "img/profile-2.65705419.jpeg";